import React from 'react';
import {Formik} from 'formik';
import ModalSendFinalPDFView from './ModalSendFinalPDF-view';
import {sendFinalPDF} from "../../actions/sendFinalPDF";
import {checkEmailIsValid} from "../../utils/form/checkEmailIsValid";
import {errors as E} from "../../constants/errors";
import {checkRequiredValues} from "../../utils/form/checkRequiredValues";
import PropTypes from "prop-types";

const ModalSendFinalPDF = ({
                             shumaId,
                             message,
                             buttonLabel,
                             recipientType,
                             recipientTypeLabel,
                             bankEmail,
                             showGlobalErrorMessage,
                           }) => {
  const handleSendFinalPDF = (selectedShumaID, recipientType, emailAddress, bodyText) => {

    return sendFinalPDF({
      selectedShumaID,
      recipientType,
      emailAddress,
      bodyText
    })
      .catch(err => showGlobalErrorMessage(err.message))
  }

  const initialValues = {
    emailAddress: '',
    bodyText: '',
  };

  const validate = values => {
    const {emailAddress} = values;
    const errors = checkRequiredValues(emailAddress, {});
    if (!checkEmailIsValid(emailAddress)) errors.emailAddress = E.INVALID_EMAIL;

    return errors
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={() => {
      }}
      validate={validate}
      enableReinitialize={true}
      validateOnChange={true}
      validateOnBlur={false}
    >
      {(formikProps) => (
        <ModalSendFinalPDFView
          shumaId={shumaId}
          message={message}
          buttonLabel={buttonLabel}
          recipientType={recipientType}
          recipientTypeLabel={recipientTypeLabel}
          handleSendFinalPDF={handleSendFinalPDF}
          bankEmail={bankEmail}
          fieldErrors={formikProps.errors}
          {...formikProps}
        />
      )}
    </Formik>
  );
};

ModalSendFinalPDF.propTypes = {
  shumaId: PropTypes.number,
  message: PropTypes.string,
  buttonLabel: PropTypes.string,
  recipientType: PropTypes.number,
  recipientTypeLabel: PropTypes.string,
  bankEmail: PropTypes.string,
};

export default ModalSendFinalPDF;
